import { observer } from "mobx-react-lite";
import {useEffect, useState} from "react";
import Btn from "../../ui/Btn";
import appStore from "../../storage/AppStore";
import {useNavigate} from "react-router-dom";
import systemStore from '../../storage/SystemStore'
import {botUsername, getProductTitle} from '../../common/config'

const Login = () => {
  const [token, setToken] = useState("");
  const navigate = useNavigate();

  useEffect(() => {
    const jwt = sessionStorage.getItem("jwt");

    if (jwt) {
      navigate("/", { replace: true });
    }
  }, []);

  const handlePaste = (e) => {
    const pasted = e.clipboardData.getData("text");
    setToken(pasted);
    e.preventDefault();
  };

  const handleLogin = async () => {
      if (!token) return;

      try {
          sessionStorage.setItem('jwt', token)
          appStore.checkToken().then(resp => {
            if (resp.success) {
              window.location.reload();
            } else {
              systemStore.setError(appStore.tr.token_incorrect || 'Incorrect Token')
              sessionStorage.removeItem('jwt')
            }
          })
          
      } catch (e) {
          console.error(e);
          systemStore.setError(appStore.tr.token_incorrect || 'Incorrect Token')
          sessionStorage.removeItem('jwt')
      }
  }
  
  const productTitle = getProductTitle()
  const bot = botUsername()

  return (
    <div className="flex align-items-center justify-content-center min-h-screen">
      <div className="card p-4 w-full md:w-6 lg:w-4">

        <div className="text-center text-xl mb-4">
          {appStore.tr.login}
        </div>

        <input
          type="text"
          value={token}
          readOnly
          onPaste={handlePaste}
          placeholder={appStore.tr.paste_jwt}
          className="w-full mb-3 p-2 border-round border-1"
        />

        <Btn
          label={appStore.tr.login}
          className="w-full"
          disabled={!token}
          onClick={handleLogin}
        />
        <br/>
        <br/>
        <div
          style={{ whiteSpace: 'pre-line', marginTop: '20px' }}
          dangerouslySetInnerHTML={{ __html: appStore.tr.login_instructions }}
        />
        <div className={"flex justify-content-center align-middle-center mt-3"}>
            <Btn icon={'pi pi-telegram'} label={productTitle} onClick={() => {
              window.open(`https://t.me/${bot}`, '_blank')
            }}/>
        </div>
      </div>
    </div>
  );
};

export default observer(Login);